/** @format */
import dynamic from "next/dynamic";
import { Layout } from "../../components/common/Layout";
const CuratedByUsWrapper = dynamic(() =>
  import("../../components/CuratedByUs")
);

export default function CuratedByUsPage() {
  const meta = {
    title:
      "Qalara | Global sourcing & wholesale | Decor & Fashion trends | India",
    description:
      "Shop curated trends at Qalara wholesale marketplace for artisanal and sustainable lifestyle products. Discover latest trends and craft forms. Shop in bulk.",
    keywords:
      "Curated, trends, values, categories, wholesale, bulk, ready-to-ship, custom, fashion, accessories, homedecor, furniture, rugs, kitchen, dining, linen, furnishings, artisanal, organic, sustainable, ecofriendly India, Southeast asia, carving, inlay, basketry, weaving, metal, global, exports, imports, vendors, suppliers",
    url: "/explore/curatedbyus/",
  };

  return (
    <Layout meta={meta}>
      <CuratedByUsWrapper />
    </Layout>
  );
}
